import { render } from "./ListeTypeTaxe.vue?vue&type=template&id=4b4785c8&ts=true"
import script from "./ListeTypeTaxe.vue?vue&type=script&lang=ts"
export * from "./ListeTypeTaxe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__